import { PaymentGroupService } from '@/services/payment-groups';
import {
  ApiPaginationParams,
  ApiQueryParams,
  ApiReactQueryOptions,
  IncludeApiQueryParam,
  ISortingParams,
} from '@/types/api';
import {
  ApiPaginatedPaymentGroups,
  ApiPaymentGroupStats,
} from '@/types/payment-groups';
import { useQuery } from '@tanstack/react-query';

interface UsePaymentGroupsProps {
  filters?: ApiQueryParams;
  pagination?: ApiPaginationParams;
  sort?: ISortingParams;
  include?: IncludeApiQueryParam;
  options?: ApiReactQueryOptions<ApiPaginatedPaymentGroups>;
}

export function usePaymentGroups(opts: UsePaymentGroupsProps) {
  const { filters, pagination, sort, include, options } = opts ?? {};

  return useQuery({
    queryKey: [PaymentGroupService.PATH, filters, pagination, sort, include],
    queryFn: () =>
      PaymentGroupService.getPaymentGroups(filters, pagination, sort, include),
    ...options,
  });
}

export function usePaymentGroupStats(
  filters?: ApiQueryParams,
  options?: ApiReactQueryOptions<ApiPaymentGroupStats>,
) {
  return useQuery({
    queryKey: [PaymentGroupService.PATH, 'stats'],
    queryFn: () => PaymentGroupService.getPaymentGroupStats(filters),
    ...options,
  });
}
